// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1czv3","buttons":"styles_buttons__2qMF_"};